import type {Dispatch, ThunkAction} from 'src/reducers';
import * as reduxApi from 'src/utils/redux-api';
import {thunkify as flow} from 'src/utils/thunks';
import {key, fetching} from 'src/utils/redux';


export const RECEIVE_CORPORATE_LABELS = 'corporate-labels/receive';

type ReceiveCorporateLabels = {
  type: 'corporate-labels/receive';
  payload: {
    corporateLabels: {
      [key: string]: string;
    };
  };
};

const receiveCorporateLabels = (payload: {
  corporateLabels: {
    [key: string]: string;
  };
}): ReceiveCorporateLabels => ({
  type: RECEIVE_CORPORATE_LABELS,
  payload,
});

export type LanguageSupportActions = ReceiveCorporateLabels;

export const getCorporateLabels: () => ThunkAction<unknown> = flow(
  key(() => 'corporate-labels'),
  fetching(),
)(
  () => (dispatch: Dispatch) =>
    dispatch(reduxApi.get('configurations/label?lng=en&ns=translations'))
      .then((payload) => {
        dispatch(
          receiveCorporateLabels({
            // @ts-expect-error - TS2322 - Type '{} | null' is not assignable to type '{ [key: string]: string; }'.
            corporateLabels: payload ?? null,
          }),
        );
      })
      .catch((err) => {
        throw err;
      }),
);
